import React, { useState } from "react"
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faArrowsAltH } from '@fortawesome/free-solid-svg-icons'
import { ReactComponent as HourglassLogo } from './hets.svg';
import { Top, Head } from './sortDivHome'

export default function FindColor({

}) {

  function hexToRGB(h) {
    let r = 0, g = 0, b = 0;

    // 3 digits
    if (h.length == 4) {
      r = "0x" + h[1] + h[1];
      g = "0x" + h[2] + h[2];
      b = "0x" + h[3] + h[3];

      // 6 digits
    } else if (h.length == 7) {
      r = "0x" + h[1] + h[2];
      g = "0x" + h[3] + h[4];
      b = "0x" + h[5] + h[6];
    }

    return "rgb(" + +r + "," + +g + "," + +b + ")";
  }

  function nameToHex(name) {
    // Get RGB from named color in temporary div
    let fakeDiv = document.createElement("div");
    fakeDiv.style.color = name;
    document.body.appendChild(fakeDiv);

    let cs = window.getComputedStyle(fakeDiv),
      pv = cs.getPropertyValue("color");

    document.body.removeChild(fakeDiv);

    // Code ripped from RGBToHex() (except pv is substringed)
    let rgb = pv.substr(4).split(")")[0].split(","),
      r = (+rgb[0]).toString(16),
      g = (+rgb[1]).toString(16),
      b = (+rgb[2]).toString(16);

    if (r.length == 1)
      r = "0" + r;
    if (g.length == 1)
      g = "0" + g;
    if (b.length == 1)
      b = "0" + b;

    return "#" + r + g + b;
  }

  const [fieldOne, setFieldOne] = useState();
  const [fieldTwo, setFieldTwo] = useState();
  const [fieldThree, setFieldThree] = useState();
  const [fieldFour, setFieldFour] = useState();
  const [icon, setIcon] = useState(faArrowsAltH);
  const [fill, setFill] = useState(false);
  const [fill2, setFill2] = useState(false);

  function clickOne(name) {
    setFieldFour(nameToHex(name));
  }

  function clickTwo(hex) {
    setFieldThree(hexToRGB("#" + hex));
  }


  return (<>
    <Top>
      <Head>Get Code By</Head>
    </Top>
    <Grid>
      <One onClick={() => { setIcon(faArrowLeft); setFill(true); setFill2(false) }} fill={fill}>Name</One>
      <FontAwesomeIcon icon={icon} />
      <Two onClick={() => { setIcon(faArrowRight); setFill2(true); setFill(false) }} fill={fill2}>Hex</Two>
    </Grid>
    <MyForm>
      <Wrap>
        {fill && <>
          <Section>
            <Label htmlFor="1">Color Name</Label>
            <input type="text" id='1' value={fieldOne} name={"1"} onChange={e => setFieldOne(e.target.value)} onKeyDown={e => { if (e.key === "Enter") { clickOne(e.target.value) } }} />
          </Section>
          <BWrap><Button color={fill2 ? fieldThree : fieldFour} type="submit" onClick={() => { clickOne(fieldOne) }}>Submit</Button></BWrap>
        </>
        }
        {fill2 && <>
          <Section>
            <Label htmlFor="2">Hex Code</Label>
            <div>#
          <input type="text" id='2' value={fieldTwo} name={"2"} onChange={e => setFieldTwo(e.target.value)} onKeyDown={e => { if (e.key === "Enter") { clickTwo(e.target.value) } }} />
            </div>
          </Section>
          <BWrap><Button color={fill2 ? fieldThree : fieldFour} type="submit" onClick={() => { clickTwo(fieldTwo) }}>Submit</Button></BWrap>
        </>
        }
      </Wrap>
      {fill && <Sub>example: white</Sub>}
      {fill2 && <Sub>example: #ffffff</Sub>}
    </MyForm>
    <Show>{fill2 && fieldThree} {fill && fieldFour}</Show>
    <Out>
      <ShowDiv>
        <CHourglassLogo color={fill2 ? fieldThree : fieldFour} />
      </ShowDiv>
    </Out>
  </>
  )
}

export const Button = styled.div`
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0,0,0,.12);
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  padding: 0 16px 0 16px;
  font-family: Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: .875rem;
  font-weight: 500;
  letter-spacing: .0892857143em;
  text-decoration: none;
  text-transform: uppercase;
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 64px;
  border: none;
  outline: none;
  line-height: inherit;
  user-select: none;
  overflow: visible;
  vertical-align: middle;
  border-radius: 4px;
  background-color: #6200ee;
  color: white;
  cursor: pointer;
  height: 36px;
  &:hover, :focus {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0,0,0,.12);
  }
  :not(:first-child) {
    margin-left: 20px;
     @media screen and (max-width: 425px) and (orientation: portrait) {
    margin-left: 0;
    margin-top: 5px;
  }
  }
    @media screen and (max-width: 425px) and (orientation: portrait) {
    min-width: 255px;
  }
`;
const CHourglassLogo = styled(HourglassLogo)`
 & .cls-6 {
   fill: ${({ color }) => color == null ? "#1374ba" : color};
}
`;

const Out = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const ShowDiv = styled.div`
  width: 400px;
  height: 400px;
`;
const Show = styled.div`
  font-size: 30px;
  text-align: center;
`;

const BWrap = styled.div`
  margin-left: 30px;
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Grid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  & svg {
    padding: 0 10px;
  }
`;

const Box = styled.div`
  cursor: pointer;
  padding: 10px;
  border: 1px solid blue;
  border-radius: 10px;
  transition: all 0.3s ease;
  min-width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const One = styled(Box)`
  background-color: ${({ fill }) => fill ? "blue" : "white"};
  color: ${({ fill }) => fill ? "white" : "blue"};
`;
const Two = styled(Box)`
background-color: ${({ fill }) => fill ? "blue" : "white"};
color: ${({ fill }) => fill ? "white" : "blue"};
`;

const Header = styled.div`
  margin-top: 20px;
  font-size: 20px;
  padding-right: 30px;
`;
const Section = styled.div`
  display: flex;
  flex-direction: row;
  & label {
    padding-right: 10px;
  }
  & div {
    & input {
      margin-left: 5px;
    }
  }
`;

const Sub = styled.div`
 font-size: 14px;
 color: gray;
`;


const Label = styled.label`

`;

const MyForm = styled.div`
margin: 20px 0;
display: flex;
flex-direction: column;
`;

